export var surfaceOrgSpacingSpace = 2;
export var surfaceOrgBreakpointSpacingSpace = 4;
export var surfaceColorVariant = "backgroundLight";